import { selectResetBooking } from "entities/orders/model/selectors";
import { useEffect } from "react";
import { useAppSelector } from "shared/lib/store";

export const useBookingReset = (callback: () => void) => {
    const resetBooking = useAppSelector(selectResetBooking);
    
    useEffect(() => {
        if (resetBooking) {
            callback?.()
        }
    // eslint-disable-next-line
    }, [resetBooking])
}